namespace Matrix.Rebalancer {
    export class TradeMacroAssignmentColumns {
        static columnsKey = 'Rebalancer.TradeMacroAssignment';
    }
}
